// removed by extract-text-webpack-plugin
module.exports = {"tab-content":"TabOeNumbers-module-tab-content-3Ru0_","tabContent":"TabOeNumbers-module-tab-content-3Ru0_","title":"TabOeNumbers-module-title-3_Eyz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/TabOeNumbers/TabOeNumbers.module.scss
// module id = 1227
// module chunks = 0